'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Button = require('../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalTrigger = function ModalTrigger(props) {
  return _react2.default.createElement(_Button2.default, Object.assign({}, props));
};
exports.default = ModalTrigger;
//# sourceMappingURL=ModalTrigger.js.map